import { Table } from 'antd';

import { EmptyComponentWithDataTestId } from '@app/components';
import { LOGS_REGISTRY_TABLE_HEADER, PREFIX, U_KEY } from '@app/constants';
import {
  LogsRegistryFilters,
  MarkAsReadModal,
  MessageModal,
} from '@app/pages/SalesFunnels/LogsRegistry/components';
import { useLogsRegistry } from '@app/pages/SalesFunnels/LogsRegistry/hooks/useLogsRegistry';
import { adaptDataToTable } from '@app/pages/SalesFunnels/LogsRegistry/utils/adaptDataToTable';

import '@app/pages/SalesFunnels/LogsRegistry/styles/LogsRegistry.desktop.scss';

export const LogsRegistry = () => {
  const {
    isSearchLogsLoading,
    logsData,
    rowsPerPage,
    pageNumber,
    totalRowsCount,
    resetFilters,
    filtersForm,
    handleTableChange,
    isGetLogsSearchResult,
    handleSubmitFilterForm,
    handleMessageModalOpen,
    messageModalOpen,
    messageModalDescription,
    handleMessageModalClose,
    rowSelection,
    selectionCount,
    openMarkAsReadModal,
    readLogsModalType,
    markAsReadModalOpen,
    handleMarkAsReadModalCancel,
    handleMarkAsRead,
    isLogsMarkAsRead,
  } = useLogsRegistry();

  return (
    <div className={`${PREFIX}logs-registry`}>
      <LogsRegistryFilters
        resetFilters={resetFilters}
        filtersForm={filtersForm}
        handleSubmitFilterForm={handleSubmitFilterForm}
        selectionCount={selectionCount}
        totalRowsCount={totalRowsCount}
        openMarkAsReadModal={openMarkAsReadModal}
      />
      <Table
        className="logs-registry-table"
        locale={{
          emptyText: <EmptyComponentWithDataTestId />,
        }}
        loading={isSearchLogsLoading || isGetLogsSearchResult}
        rowKey={(record) => String(record[U_KEY])}
        columns={LOGS_REGISTRY_TABLE_HEADER}
        dataSource={adaptDataToTable(logsData, handleMessageModalOpen)}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        pagination={{
          size: 'default',
          showSizeChanger: true,
          total: totalRowsCount,
          pageSize: rowsPerPage,
          position: ['bottomLeft'],
          current: pageNumber,
          onChange: handleTableChange,
          showTotal: (total, range) =>
            `Показаны ${range[0]}-${range[1]} из ${total}`,
        }}
      />
      <MessageModal
        open={messageModalOpen}
        handleModalClose={handleMessageModalClose}
        messageText={messageModalDescription}
      />
      <MarkAsReadModal
        markType={readLogsModalType}
        open={markAsReadModalOpen}
        handleMarkAsReadModalCancel={handleMarkAsReadModalCancel}
        handleMarkAsRead={handleMarkAsRead}
        isLoading={isLogsMarkAsRead}
      />
    </div>
  );
};
